import {
  COLOR_GRADIENT,
  COLOR_NEUTRAL,
  COLOR_NEUTRAL_DARKEST,
  COLOR_NEUTRAL_MID,
  COLOR_PRIMARY,
  COLOR_PRIMARY_MID,
  COLOR_WH,
} from '../colors.constants';

export const colorsButton = {
  buttonDisabledColor: COLOR_NEUTRAL_MID,
  //  contained button
  buttonContainedBackground: COLOR_GRADIENT,
  buttonContainedColor: COLOR_NEUTRAL_DARKEST,
  buttonContainedBackgroundHover: COLOR_PRIMARY_MID,
  buttonContainedColorHover: COLOR_NEUTRAL_DARKEST,
  //  contained secondary button
  buttonContainedSecondaryBackground: COLOR_NEUTRAL_DARKEST,
  buttonContainedSecondaryColor: COLOR_WH,
  buttonContainedSecondaryBackgroundHover: COLOR_WH,
  buttonContainedSecondaryColorHover: COLOR_NEUTRAL_DARKEST,
  buttonContainedSecondaryBorderHover: `1px solid ${COLOR_NEUTRAL}`,
  // outlined button
  buttonOutlinedBackground: 'transparent',
  buttonOutlinedColor: COLOR_NEUTRAL,
  buttonOutlinedBorder: `1px solid ${COLOR_NEUTRAL}`,
  buttonOutlinedColorHover: COLOR_NEUTRAL_DARKEST,
  buttonOutlinedBorderHover: `1px solid ${COLOR_NEUTRAL_DARKEST}`,
  // text button
  buttonTextColor: COLOR_NEUTRAL,
  buttonTextColorHover: COLOR_PRIMARY,
};
